<template>
  <div class="bg pt-0">
    <demo-login-modal />
    <div>
      <CoolLightBox :items="limages" :index="imgindex" @close="imgindex = null">
      </CoolLightBox>
    </div>
    <div class="row first">
      <div class="col-lg-12 col-sm-12 chooseroom">
        <form action method="post" class="form-inner">
          <div class="container">
            <form action method="post" class="form-inner">
              <div class="row form-group rooms w-50" style="display: none">
                <div class="col-lg-3 col-sm-12">
                  <base-input>
                    <input
                      type="radio"
                      @change="fullclearCities"
                      name="international"
                      value="no"
                      v-model="international"
                    />
                    India
                  </base-input>
                </div>
                <div class="col-lg-3 col-sm-12">
                  <base-input>
                    <input
                      type="radio"
                      @change="fullclearCities"
                      name="international"
                      value="yes"
                      v-model="international"
                    />
                    International
                  </base-input>
                </div>
              </div>
              <div class="row form-group rooms">
                <div class="col-lg-3 col-sm-6">
                  <h6>Hotel</h6>
                  <strong>{{ hoteldata.hotel_name }}</strong>
                  <!-- {{hoteldata.combo_dates}} -->
                  <!-- <div  
                    :key="combodatesindex"
                    v-for="(comboDate, combodatesindex) in (
                      hoteldata.combo_dates || ','
                    ).split(',')"
                  >
                  
                    {{ 
                       comboDate.split('-')[2]+ '-' + comboDate.split('-')[1] + '-' + comboDate.split('-')[0] 
                     }}
                  </div> -->
                  <!-- {{combodate}} -->
                </div>
                <div class="col-lg-2 col-sm-6">
                  <h6>Check-In Date</h6>
                  <div
                    class="
                      input-daterange
                      datepicker
                      row
                      align-items-center
                      flatpickr"
                  >
                    <div class="col" v-if=" combohotelbool=='no' && combodates.length >= 1">
                      <!-- <base-input addon-left-icon="fa-lg calendar"> -->
                      <base-input addon-right-icon="fa fa-calendar">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          @input="checkdates"
                          :config="{
                            allowInput: true,
                            minDate: 'today',
                          }"
                          class="form-control datepicker"
                          v-model="datein"
                        ></flat-picker>
                      </base-input>
                      <!-- <i class="fa fa-calendar fa-lg calendar" aria-hidden="true"></i> -->
                    </div>
                    <div class="col" v-if="combohotelbool=='yes' && combodates.length > 0 ">
                      <!-- <base-input addon-left-icon="fa-lg calendar"> -->
                      <base-input addon-right-icon="fa fa-calendar">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          @input="checkdates"
                          :config="{
                            allowInput: true,
                            minDate: 'today',
                            enable: combodates ? combodates : [],
                          }"
                          class="form-control datepicker"
                          v-model="datein"
                        ></flat-picker>
                      </base-input>
                      <!-- <i class="fa fa-calendar fa-lg calendar" aria-hidden="true"></i> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6">
                  <h6>Check-Out Date</h6>

                  <div
                    class="input-daterange datepicker row align-items-center"
                  >
                    <div class="col">
                      <base-input addon-right-icon="fa fa-calendar">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          @input="checkdates"
                          :config="{
                            allowInput: true,
                            minDate: datein,
                          }"
                          class="form-control datepicker"
                          v-model="dateout"
                        ></flat-picker>
                      </base-input>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                  <h6>Guests & Rooms</h6>
                  <input
                    v-model="roomstring"
                    class="form-control"
                    @click="showRoomPopup"
                    value=""
                    placeholder="Select Rooms & No of Guests"
                  />
                </div>
                <div v-show="showselectrooms" class="selectroom">
                  <div class="row">
                    <div class="col-lg-3 col-sm-6">
                      <h6>Rooms</h6>
                      <number-input
                        @change="checkroom"
                        v-model="trooms"
                        :min="1"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-3 col-sm-6">
                      <h6>Adults</h6>
                      <number-input
                        @change="checkadults"
                        v-model="guests"
                        :min="1"
                        :max="12"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-3 col-sm-6">
                      <h6>Children Blow 6 Year</h6>
                      <number-input
                        v-model="guestsChildren"
                        :min="0"
                        :max="12"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-3 col-sm-6">
                      <h6>Children Above 6 Year</h6>
                      <number-input
                        v-model="guestsChildrenabove"
                        :min="0"
                        :max="12"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-12 col-sm-6 text-center">
                      <h6>&nbsp;</h6>
                      <button
                        @click="showRoomPopup"
                        type="button"
                        class="btn btn-warning"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-lg-12 col-sm-12">
                <h6>TRAVELLING FOR</h6>
                
                <multiselect
                  :multiple="false"
                  placeholder="Select a Reason"
                  v-model="travfor"
                  :options="travforoptions"
                ></multiselect>
                
                </div>-->
                <div class="col-lg-2 col-sm-6 text-center">
                  <h6>&nbsp;</h6>
                  <button
                    @click="submitsearch"
                    type="button"
                    class="primaryBtn2 btn btn-primary"
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </form>
      </div>
    </div>

    <div class="container">
      <div class="row mt-2 single-hotel-detail pb-3" id="photos">
        <div class="col-md-8 col-sm-12">
          <carousel
            :navigationEnabled="true"
            :paginationEnabled="false"
            :scrollPerPage="false"
            :perPage="1"
            :perPageCustom="[
              [480, 1],
              [768, 1],
              [1199, 1],
            ]"
          >
            <!-- <div v-if="hoteldata.hotel_images"> -->

            <slide
              v-bind:key="himgindex"
              v-for="(himg, himgindex) in (hoteldata.hotel_images || ',').split(
                ','
              )"
            >
              <img
                @click="showlightbox(himgindex, hoteldata.hotel_images_full)"
                v-lazy="'https://hotellele.com/fcrm/uploads/hotels/' + himg"
                class="hotelimg"
              />
            </slide>
            <!-- </div> -->
          </carousel>
          <div class="hoteltext">Hotel Images</div>
          <h3>
            <small>
              <i
                v-for="index in Number(hoteldata.hotel_stars)"
                v-bind:key="index"
                class="fa fa-star fa-xs starsize"
                aria-hidden="true"
              ></i>
            </small>
          </h3>
          <p>{{ hoteldata.hotel_address }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <div
            v-bind:key="room.room_id"
            v-for="room in hoteldata.hotel_rooms.slice(0, 1)"
          >
            <div class="directbookroom">
              <h5>
                {{ room.room_name }}
              </h5>
              <div class="inclusions">
                <ul>
                  <li
                    v-bind:key="rhighs"
                    v-for="(rhighs, rhindex) in room.room_highlights.split(',')"
                  >
                    <small v-if="rhindex < 5" class="rhigh"
                      ><span
                        ><i class="fa fa-check"></i> {{ rhighs }}</span
                      ></small
                    >
                  </li>
                </ul>
                <h5 class="color">
                  Our Ratings
                  <span class="color ourrating">
                    {{ hoteldata.own_rating }} / 5</span
                  >
                </h5>
              </div>
              <div
                v-if="
                  maxguest > room.room_total_person &&
                  combohotelbool == 'no' &&
                  dircethotel == 'no'
                "
              >
                <!-- <span hidden>
                  {{
                    (totalrooms = Math.ceil(maxguest / room.room_total_person))
                  }}
                </span> -->
              </div>
              <div
                v-else-if="
                  combohotelbool == 'no' && maxguest < room.room_total_person
                "
              >
                <!-- <span hidden>
                  {{
                    (totalrooms = Math.ceil(maxguest / room.room_total_person))
                  }}
                </span> -->
              </div>
              <div class="directbookroomprice2">
                <h4 v-if="combohotelbool == 'no' && dircethotel == 'no'">
                  <small style="color: red">
                    <s>
                      <span>&#8377;</span>
                      {{ room.room_gross_price * Math.ceil(totalrooms) }} </s
                    ><br />
                  </small>
                  <span
                    >&#8377;
                    <strong>{{
                      room.room_price * Math.ceil(totalrooms)
                    }}</strong></span
                  >&nbsp; 
                  <span class="Savingprice">
                    <small>
                      Saving : &#8377;
                     
                      <span
                        >{{
                          Math.ceil(totalrooms) * room.room_gross_price -
                          Math.ceil(totalrooms) * room.room_price
                        }}
                      </span>
                    </small>
                  </span>
                  <p>
                    <small class="fontsmall"
                      >Per Night For {{ Math.ceil(totalrooms) }} Rooms</small
                    >
                  </p>
                </h4>
                <h4 v-if="combohotelbool == 'yes'">
                  <small style="color: red">
                    <s>
                      <span>&#8377;</span>
                      {{
                        hoteldata.combo_gross_amt * Math.ceil(totalrooms)
                      }} </s
                    ><br />
                  </small>
                  <span
                    >&#8377;
                    <strong>{{
                      hoteldata.combo_net_amt * Math.ceil(totalrooms)
                    }}</strong></span
                  >&nbsp;
                  
                  <span class="Savingprice">
                    <small>
                      Saving : &#8377;
                      <span
                        >{{
                          Math.ceil(totalrooms) * hoteldata.combo_gross_amt -
                          Math.ceil(totalrooms) * hoteldata.combo_net_amt
                        }}
                      </span>
                    </small>
                  </span>
                  <p>
                    <small class="fontsmall">Per Person</small>
                  </p>
                </h4>
                <h4 v-if="dircethotel == 'yes'">
                  <small style="color: red">
                    <s><span>&#8377;</span>
                      {{ room.room_gross_price * Math.ceil(totalrooms) }} </s><br />
                  </small>
                  <span>&#8377;
                    <strong>{{room.room_price * Math.ceil(totalrooms) }}</strong></span>&nbsp;
                  <span class="Savingprice">
                    <small>
                      Saving : &#8377;
                      <span>{{
                          Math.ceil(totalrooms) * room.room_gross_price -
                          Math.ceil(totalrooms) * room.room_price
                        }}
                      </span>
                    </small>
                  </span>
                  <p>
                    <small class="fontsmall">Per Night For {{ Math.ceil(totalrooms) }} Rooms</small>
                  </p>
                </h4>
                <table
                 style="display: none;"
                  id="extra"
                  v-if="guests > room.max_adults && Math.ceil(totalrooms) == 1"
                >
                  <tr>
                    <th colspan="3" id="firstrow">Extra Person Charges</th>
                  </tr>
                  <tr
                    v-if="
                      guests > room.max_adults && Math.ceil(totalrooms) == 1
                    "
                  >
                    <td>
                      <span class="tableth"
                        ><b>
                          Adults<span style="color: red">
                            {{ guests - room.max_adults }}</span
                          >
                        </b></span
                      >
                    </td>
                    <td>
                      {{ Math.round(room.extra_per_adults, 0) }}
                    </td>
                    <td>
                      {{ (guests - room.max_adults) * room.extra_per_adults }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      guestsChildren > 0 &&
                      room.extra_per_children_under_six > 0
                    "
                  >
                    <td>
                      <span class="tableth">
                        <b
                          >Child Blow 6 Years
                          <span style="color: red">{{ guestsChildren }}</span>
                        </b>
                      </span>
                    </td>
                    <td>
                      {{ Math.round(room.extra_per_children_under_six, 0) }}
                    </td>
                    <td>
                      {{ guestsChildren * room.extra_per_children_under_six }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      (guestsChildrenabove) =>
                        room.max_children &&
                        room.extra_per_children_more_six > 0
                    "
                  >
                    <td>
                      <span class="tableth">
                        <b
                          >Child Above 6 years
                          <span style="color: red">
                            {{ guestsChildrenabove }}
                          </span>
                        </b>
                      </span>
                    </td>
                    <td>
                      {{ Math.round(room.extra_per_children_more_six, 0) }}
                    </td>
                    <td>
                      {{
                        guestsChildrenabove * room.extra_per_children_more_six
                      }}
                    </td>
                  </tr>
                </table>
              </div>

              <div class="line"></div>

              <div class="bookedbtn">
                <a href="#room">Other Rooms</a>

                <Button
                  class="btn btn-primary"
                  @click="gotoBook(room.room_id, Math.ceil(totalrooms))"
                  >Book Now</Button
                >
              </div>
            </div>
          </div>
          <!-- <div class="map" v-show="showmap">
            <gmap-map
              :center="center"
              :zoom="12"
              style="width: 100%; height: 375px; max-height: 430px"
            >-->
          <!-- <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position"></gmap-marker>-->
          <!-- </gmap-map>
          </div>  -->
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-12 list mt-1">
              <ul>
                <li>
                  <a href="#room" v-smooth-scroll>Rooms</a>
                </li>
                <li>
                  <a href="#reviews" v-smooth-scroll>Reviews</a>
                </li>
                <li>
                  <a href="#hotelpolicies" v-smooth-scroll>Hotel policies</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="row m-0" id="room">
            <div class="col-md-4 col-sm-12 roomhead">ROOM TYPE</div>
            <div class="col-md-3 col-sm-12 roomhead">OPTIONS</div>
            <div class="col-md-3 col-sm-12 roomhead">
              INCLUDED IN THIS PRICE
            </div>
            <div class="col-md-2 col-sm-12 roomhead">PRICE</div>

            <div
              class="row"
              v-bind:key="room.room_id"
              v-for="room in hoteldata.hotel_rooms"
            >
              <div class="row roomtable">
                <div class="col-md-4 col-sm-12">
                  <h4>{{ room.room_name }}</h4>
                  <carousel
                    class="roomcarousel"
                    v-if="room.room_images.length > 0"
                    :navigationEnabled="true"
                    :paginationEnabled="true"
                    :scrollPerPage="false"
                    :perPage="1"
                    :perPageCustom="[
                      [480, 1],
                      [768, 1],
                      [1199, 1],
                    ]"
                  >
                    <slide
                      v-bind:key="rimgindex"
                      v-for="(rimg, rimgindex) in room.room_images.split(',')"
                    >
                      <img
                        @click="
                          showlightbox(rimgindex, room.room_images.split(','))
                        "
                        v-lazy="
                          'https://hotellele.com/fcrm/uploads/hotel_rooms/' +
                          rimg
                        "
                        class="roomimg"
                      />
                    </slide>
                  </carousel>

                  <ul>
                    <li v-if="room.room_size != ''">
                      <span class="rhigh">
                        upto {{ room.room_size }} {{room.room_size_area}}
                      </span>
                    </li>
                    <li v-if="room.room_bedtype != ''">
                      <span class="rhigh">
                        Bed-Type {{ room.room_bedtype }}
                      </span>
                    </li>
                    <li>
                      <span v-if="room.room_freecancellation != '1'" class="red"
                        >Non-Refundable</span
                      >
                      <span
                        v-else-if="room.room_freecancellation == '1'"
                        class="red"
                        >Free Cancellation</span
                      >
                    </li>
                    <li v-if="room.room_couplefriendly == '1'">
                      <span class="red"> couple friendly </span>
                    </li>
                  </ul>
                </div>
                <div class="col-md-3 col-sm-12">
                  <small
                    class="rhigh"
                    v-bind:key="rhighs"
                    v-for="(rhighs, rhindex) in room.room_highlights.split(',')"
                    ><span v-if="rhindex < 5"
                      ><i class="fa fa-check"></i> {{ rhighs }}
                    </span></small
                  >
                </div>
                <div class="col-md-3 col-sm-12 test">
                  &nbsp;
                  <small
                    class="mt-2 room_inclusions"
                    v-html="room.room_inclusions"
                  ></small>
                  <span
                    v-if="(room.room_amenities = ' ')"
                    class="amenitiesspace"
                    ><b>Amenities</b><br
                  /></span>
                  <small
                    class="amenities"
                    v-bind:key="arhighs"
                    v-for="(arhighs, arhindex) in (
                      room.room_amenities || ','
                    ).split(',')"
                    ><span v-if="arhindex < 10 && arhindex.length > 0"
                      ><i class="fa fa-check"></i> {{ arhighs }}
                    </span> </small
                  ><br />
                </div>
                <div class="col-md-2 col-sm-12">

                  <h4 v-if="dircethotel == 'yes'">
                    <small>
                      <s style="color: red">
                        <span>&#8377;</span>
                        {{ room.room_gross_price * Math.ceil(totalrooms) }}
                      </s>
                    </small>
                    <br />
                    <span>&#8377;</span>
                    <strong>{{
                      room.room_price * Math.ceil(totalrooms)
                    }}</strong>
                    <span class="Savingpricetable">
                      Saving <br />&#8377;
                      {{
                        Math.ceil(totalrooms) * room.room_gross_price -
                        Math.ceil(totalrooms) * room.room_price
                      }}
                    </span>
                    <span hidden>{{
                      (totalRoomsArray[room.room_id] = Math.ceil(totalrooms))
                    }}</span>
                  </h4>

                  <h4 v-if="combohotelbool == 'yes'">
                    <small>
                      <s style="color: red">
                        <span>&#8377;</span>
                        {{ hoteldata.combo_gross_amt * Math.ceil(totalrooms) }}
                      </s>
                    </small>
                    <br />
                    <span>&#8377;</span>
                    <strong>{{
                      hoteldata.combo_net_amt * Math.ceil(totalrooms)
                    }}</strong>
                    <span class="Savingpricetable">
                      Saving <br />&#8377;
                      {{
                        Math.ceil(totalrooms) * hoteldata.combo_gross_amt -
                        Math.ceil(totalrooms) * hoteldata.combo_net_amt
                      }}
                    </span>
                    <span hidden>{{
                      (totalRoomsArray[room.room_id] = Math.ceil(totalrooms))
                    }}</span>
                  </h4>

                  <table style="display: none;"
                    id="extratable"
                    v-if="
                      guests > room.max_adults &&
                      Math.ceil(totalrooms) == 1 &&
                      (room.extra_per_adults > 0 ||
                        room.extra_per_children_under_six > 0 ||
                        room.extra_per_children_more_six > 0)
                    "
                  >
                    <tr>
                      <td colspan="3" id="firstrow">Extra Person Charges</td>
                    </tr>
                    <tr
                      v-if="
                        (guests) =>
                          room.max_adults &&
                          Math.ceil(totalrooms) == 1 &&
                          room.extra_per_adults > 0
                      "
                    >
                      <td>
                        <span class="tableth">
                          <b
                            >Adults
                            <span style="color: red">{{
                              guests - room.max_adults
                            }}</span>
                          </b></span
                        >
                      </td>
                      <td>
                        {{ Math.round(room.extra_per_adults, 0) }}
                      </td>
                      <td>
                        {{ (guests - room.max_adults) * room.extra_per_adults }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        (guestsChildren) =>
                          0 && room.extra_per_children_under_six > 0
                      "
                    >
                      <td>
                        <span class="tableth">
                          <b
                            >Child Blow 6 Years
                            <span style="color: red">{{ guestsChildren }}</span>
                          </b>
                        </span>
                      </td>
                      <td>
                        {{ Math.round(room.extra_per_children_under_six, 0) }}
                      </td>
                      <td>
                        {{ guestsChildren * room.extra_per_children_under_six }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        (guestsChildrenabove) =>
                          room.max_children &&
                          room.extra_per_children_more_six > 0
                      "
                    >
                      <td>
                        <span class="tableth">
                          <b
                            >Child Above 6 Years
                            <span style="color: red">{{
                              guestsChildrenabove
                            }}</span>
                          </b>
                        </span>
                      </td>
                      <td>
                        {{ Math.round(room.extra_per_children_more_six, 0) }}
                      </td>
                      <td>
                        {{
                          guestsChildrenabove * room.extra_per_children_more_six
                        }}
                      </td>
                    </tr>
                  </table>

                  <h5 v-if="combohotelbool == 'no' || dircethotel == 'yes'">
                    <small class="fontsmall">
                      Per Night for {{ Math.ceil(totalrooms) }} Rooms</small
                    >
                  </h5>
                  <h5 v-if="combohotelbool == 'yes'">
                    <small class="fontsmall"> Per Person</small>
                  </h5>

                  <Button
                    class="btn btn-primary"
                    @click="gotoBook(room.room_id, Math.ceil(totalrooms))"
                    >Book Now</Button
                  >
                </div>
              </div>
            </div>
          </div>
          <h4 class="roomhead">HIGHLIGHTS</h4>
          <div v-html="hoteldata.hotel_features"></div>
          <h4 class="overview">OVERVIEW</h4>
          <div v-html="hoteldata.hotel_description" class="overviewtext"></div>
        </div>
      </div>

      <!-- <div class="row mt-4" id="reviews">
        <div class="col-md-12 col-sm-12">
          <h4>REVIEWS</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-sm-12 reviews">
          <div class="row review-detail">
            <div class="col-md-3">View Hotel Reviews (0)</div>
            <div class="col-md-3">View Room Reviews (0)</div>
          </div>
        </div>
      </div> -->
      <div class="row mt-4" id="map" v-show="showmap">
        <div class="col-md-12 col-sm-12">
          <h4>MAP VIEW</h4>
        </div>
      </div>

      <div class="row mt-4" id="hotelpolicies">
        <div class="col-md-12 col-sm-12">
          <h4>HOTEL POLICIES</h4>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-sm-12 reviews">
          <div class="row review-detail">
            <div class="col-md-3">
              <h6>
                <i class="fa fa-clock" aria-hidden="true"></i>
                CHECKIN : {{ hoteldata.checkin_time }}
              </h6>
            </div>
            <div class="col-md-3">
              <h6>
                <i class="fa fa-clock" aria-hidden="true"></i>
                CHECKOUT : {{ hoteldata.checkout_time }}
              </h6>
            </div>
            <div class="col-md-3">
              <h6>
                <i class="fa fa-tag" aria-hidden="true"></i>
                ROOMS : {{ hoteldata.no_of_rooms }}
              </h6>
            </div>
            <div class="col-md-3">
              <h6>
                <i class="fa fa-stairs" aria-hidden="true"></i>
                FLOORS : {{ hoteldata.no_of_floors }}
              </h6>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12 reviews">
            {{ hoteldata.hotel_policies }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIURLS } from "../../api/constants";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CoolLightBox from "vue-cool-lightbox";
import DemoLoginModal from "../modals/modal_login";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import moment from "moment";

export default {
  name: "HotelDetailMiddle",
  components: {
    flatPicker,
    CoolLightBox,
    DemoLoginModal,
  },
  props: {
    hotelid: String,
    checkindate: String,
    checkoutdate: String,
  },

  data() {
    return {
      international: "no",
      guests: 2,
      trooms: localStorage.getItem("trooms"),
      guestsChildren: 0,
      guestsChildrenabove: 0,
      travforoptions: ["Work", "Leisure"],
      travfor: null,
      isCitiesLoading: false,
      cityvalue: null,
      showselectrooms: false,
      isHotelsFilterLoading: false,
      maxguests: 12,
      totalguest: 0,
      fullguests: false,
      roomstring: "",
      datein: new Date(),
      dateout: new Date().setDate(new Date().getDate() + 1),
      enabledate: [],
      maxguest: localStorage.getItem("totalguest"),
      totalrooms: localStorage.getItem("trooms"),
      totalRoomsArray: {},
      combohotelbool: " ",
      dircethotel: " ",
      combodates: [],
      weekday: "",
      hoteloptions: [
        {
          id: "0",
          name: "Please type slowly and select hotels",
        },
      ],
      cityoptions: [
        {
          id: "0",
          name: "Please type slowly and select cities",
        },
      ],
      dates: {
        simple: "2016-07-17",
        rangein: new Date(),
        rangeout: new Date().setDate(new Date().getDate() + 1),
      },

      center: { lat: 0, lng: 0 },
      searchhotel: null,
      hotelprice: 0,
      showmap: false,
      hoteldata: "",
      imgindex: null,
      limages: [],
    };
  },
  watch: {
    totalrooms: {
      deep: true,
      handler() {
        if (
          this.$route.query.from != "hotelwise" &&
          this.$route.query.from != "combo"
        ) {
          localStorage.setItem("trooms", this.totalrooms);
        } else {
          localStorage.setItem("trooms", this.$route.query.tr);
        }
      },
    },
  },
  methods: {
    gotohotel(selectionOption, id) {},
    gotoBook(roomid, tr) {
     // debugger;
      localStorage.setItem("trooms", this.totalRoomsArray[roomid]);
      this.$router.push({ path: "bookhotel", query: { roomid: roomid } });
    },
    showlightbox(index, arr) {
      this.limages = null;
      this.limages = arr.split(",");

      this.imgindex = index;
    },
    totalguests() {
      this.maxguests = 12;
      this.totalguest =
        this.guests + this.guestsChildren + this.guestsChildrenabove;
      this.maxguests =
        this.maxguests -
        this.guests -
        this.guestsChildren -
        this.guestsChildrenabove;

      if (this.maxguests == 0) {
        this.fullguests = true;
      }
    },
    checkadults() {
      if (this.guests == 12) {
        this.fullguests = true;
        this.guestsChildren = 0;
        this.guestsChildrenabove = 0;
      } else if (this.guests < 12) {
        this.fullguests = false;
      }
    },
    checkroom() {
      if (this.trooms >= 1) {
        if (this.guests < this.trooms * 2) {
          this.guests = this.trooms * 2;
        } else {
          this.guests = this.trooms * 2;
        }
      }
    },
    clearHotelSearch() {
      this.hoteloptions = [];
      
    },
    getHotelsSearch(query) {
      this.clearHotelSearch();
      this.isHotelsFilterLoading = true;

      var urltogo = APIURLS.GET_HOTEL_SEARCH + "?q=" + query;

      axios.get(urltogo).then((response) => {
        this.hoteloptions = response.data;
        this.isHotelsFilterLoading = false;
      });
      //  console.log(response.data);
    },
    checkdates() {
      //  alert(this.datein);
      //  this.dateout = "";
      // this.dateout = moment(String(this.datein)).format("YYYY-MM-DD");
      // .add(1, "day")
      // .format("YYYY-MM-DD");
      //  this.$forceUpdate();
      var comobo =localStorage.getItem('combohotel');
      var NumbersDay=localStorage.getItem('comboday');
      if(comobo=='combe')
      {
             this.dateout=moment(String(this.datein)).add(NumbersDay,'days').format("YYYY-MM-DD");
      }
    },

    showRoomPopup() {
      this.showselectrooms = !this.showselectrooms;
      this.roomstring =
        this.guests +
        this.guestsChildren +
        this.guestsChildrenabove +
        " Guests and " +
        this.trooms +
        " Room(s)";
      // alert(this.guests + this.guestsChildren + this.guestsChildrenabove);
      // alert(room.room_total_person);
      // totalrooms = Math.ceil(totaltextbox / room.room_total_person);
      // this.trooms=totalrooms;
      // alert(totalrooms);
    },
    limitText(count) {
      return `and ${count} other cities`;
    },
    getCities(query) {
      this.clearCities();
      this.isCitiesLoading = true;

      var urltogo =
        APIURLS.GET_CITIES +
        "?q=" +
        query +
        "&international=" +
        this.international;
      axios.get(urltogo).then((response) => {
        this.cityoptions = response.data;
        this.isCitiesLoading = false;
      });
    },
    clearCities() {
      this.cityoptions = [];
    },
    fullclearCities() {
      this.cityvalue = null;
      this.getCities("");
    },
    submitsearch() {
      // var cityString = this.cityvalue.id;
      // var cityNameString = this.cityvalue.name;

      var datein1 = moment(String(this.datein)).format("YYYY-MM-DD");
      var dateout1 = moment(String(this.dateout)).format("YYYY-MM-DD");
      localStorage.setItem("checkin", datein1);
      localStorage.setItem("checkout", dateout1);
      localStorage.setItem("guests", this.guests);
      localStorage.setItem("guestsChildren", this.guestsChildren);
      localStorage.setItem("guestsChildrenabove", this.guestsChildrenabove);
      localStorage.setItem("trooms", this.trooms);
      this.weekday = new Date(localStorage.getItem("checkin")).getDay();
      this.totalguest =
        this.guests + this.guestsChildren + this.guestsChildrenabove;
      localStorage.setItem("totalguest", this.totalguest);
      this.maxguest = localStorage.getItem("totalguest");
      this.$alertify.success("Saved");
    },

    getHotel() {
      var tempCheckInDate = localStorage.getItem("checkin");
      var tempCheckOutDate = localStorage.getItem("checkout");
      if (this.$route.query.from == "combo") {
        var combowise = "yes";
      } else {
        var combowise = "no";
      }

      axios
        .post(
          `${APIURLS.GET_HOTEL_DETAIL}?hotelid=${this.hotelid}&checkindate=${tempCheckInDate}&checkoutdate=${tempCheckOutDate}&combohotel=${localStorage.getItem("combohotel")}`,
          {
            hotelid: this.hotelid,
            checkindate: tempCheckInDate,
            checkoutdate: tempCheckOutDate,
            combohotel:localStorage.getItem("combohotel"),
          }
        )
        .then((response) => {
          this.hoteldata = response.data;
          var roompriceavgarray = 0;
          this.hoteldata.hotel_rooms.forEach((room) => {
            room.room_weekend_days

            roompriceavgarray = roompriceavgarray + room.room_price;
          });
          if (this.hoteldata.combo_dates.length > 0) {
            var DateArry = this.hoteldata.combo_dates.split(",");
            DateArry.forEach((date) => {
              var mydate =
                date.split("-")[2] +
                "-" +
                date.split("-")[1] +
                "-" +
                date.split("-")[0];
              this.combodates.push(mydate);
            });
          }
          if (this.hoteldata.hotel_rooms.length > 0) {
            this.hotelprice =
              roompriceavgarray / this.hoteldata.hotel_rooms.length;
          }
          this.center = {
            lat: this.hoteldata.hotel_latituge,
            lng: this.hoteldata.longitude,
          };

          if (this.hoteldata.hotel_latituge && this.hoteldata.longitude) {
            if (
              this.hoteldata.hotel_latituge != "" &&
              this.hoteldata.longitude != ""
            ) {
              this.showmap = true;
            }
          }
        });
    },
  },
  beforeMount() {
    this.weekday = new Date(localStorage.getItem("checkin")).getDay();

    //  alert((this.weekday));
    //debugger;
    localStorage.setItem("trooms", this.$route.query.tr);
    if (this.$route.query.from == "combo") {
      this.combohotelbool = "yes";
      this.totalrooms = 1;
      localStorage.setItem("combohotel", "combe");
    } else if (this.$route.query.from == "hotelwise") {
      this.dircethotel = "yes";
      this.totalrooms = 1;
      localStorage.setItem("combohotel", "hotel");
      this.combohotelbool = "no";
    } else {
      localStorage.setItem("combohotel", "hotel");
      this.combohotelbool = "no";
      this.dircethotel = "yes";
      this.totalrooms = 1;
    }
  },
  
  mounted() {
    if (this.hotelid) {
      if (this.hotelid != "") {
        this.getHotel();
        this.searchhotel = [
          {
            id: this.hotelid,
            name: this.hoteldata.hotel_name,
          },
        ];
      }
    }
    //console.log(this.$route.query.tr);
    //localStorage.setItem("trooms", this.$route.query.tr);
    this.totalrooms = this.$route.query.tr;
    var dateIn = localStorage.getItem("checkin");
    var dateOut = localStorage.getItem("checkout");
    var g = localStorage.getItem("guests");
    var gc = localStorage.getItem("guestsChildren");
    var gcs = localStorage.getItem("guestsChildrenabove");
    var tr = localStorage.getItem("trooms");

    if (g != null && gc != null) {
      if (g != "" && gc != "") {
        this.guests = parseInt(g, 10);
        if (gc > 0) {
          this.guestsChildren = parseInt(gc, 10);
        } else {
          this.guestsChildren = 0;
        }

        if (gcs > 0) {
          this.guestsChildrenabove = parseInt(gcs, 10);
        } else {
          this.guestsChildrenabove = 0;
        }

        var totalguests =
          +this.guests + +this.guestsChildren + +this.guestsChildrenabove;
        this.roomstring = totalguests + " Guests and " + tr + " Room(s)";
      }
    }

    if (dateIn != null && dateOut != null) {
      if (dateIn != "" && dateOut != "") {
        this.datein = moment(String(dateIn)).format("YYYY-MM-DD");
        this.dateout = moment(String(dateOut)).format("YYYY-MM-DD");
      }
    }

    this.getCities("");
  },
  
};
</script>

<style scoped>
.Savingpricetable {
  font-size: 0.6em;
  color: #083578;
  float: right;
  margin-top: -1.5em;
  margin-right: 1em;
  font-weight: 700;
}

#firstrow {
  background-color: #4caf50;
  color: #fff;
  font-size: 1.2em;
  padding: 0.2em 3.5em;
  font-weight: 400;
  text-align: center;
}
#extratable tr td,
#extra tr td {
  border: 1px solid #000;
}
#extra tr td {
  font-size: 1em;
  padding: 0.2em 0.2em;
}
#extratable #firstrow {
  font-size: 1em;
}
#extratable tr td {
  padding: 0.2em 0.4em;
  font-size: 1em;
}
/* #extra tr td:nth-last-child(3) {
  padding: 0 1.2em;
}
#extra tr td:nth-last-child(2) {
  padding: 0 1.2em;
}
#extra tr td:nth-last-child(1) {
  padding: 0 1.2em;
} */

.tableth {
  font-size: 0.6em;
  color: #000;
  font-weight: 400;
}

.overview {
  margin-top: 1.6em;
}
.position-relative {
  background-color: #f4f5f7;
}
.ourrating {
  background-color: #6773e6;
  color: #fff;
  border-radius: 10px;
  padding: 1% 2%;
  font-size: 1rem;
}
.mt-2 {
  margin-top: 2rem;
}
.bg {
  scroll-behavior: smooth;
  background-color: #f4f5f7;
  padding: 1rem;
  margin: 0;
  padding-bottom: 7%;
}
.fontsmall {
  font-size: 0.6em;
}
#secoud > .col-md-2 {
  border: unset;
}
.hoteldetail {
  background-color: #fff;
}
.discount {
  color: #007bff;
}
.discount > s {
  color: #000;
}
.directbookroom {
  border: 0.1rem solid #dedff3;
  padding: 0.2rem 1rem;
  border-radius: 0px;
}
.directbookroomprice {
  position: absolute;
  top: 0;
  right: 4%;
  padding-right: 1rem;
}
.directbookroomprice > h4 > small {
  color: red;
  font-size: 1rem;
  margin-left: 25%;
}

.directbookroomprice > h4 > small::after,
.directbookroomprice > h4 > span::after {
  content: "\A";
  white-space: pre;
}
.Savingprice {
  position: absolute;
  font-size: 0.9em;
  color: #007bff;
  margin-top: -1.5em;
  margin-left: 1em;
  font-weight: 700;
}

.price {
  font-size: 2.1rem;
  font-weight: 800;
}

.symbol {
  font-size: 1.8rem;
  font-weight: 100;
}

/* .list{
  
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;  
} */
.list > ul {
  margin-bottom: 0px;
  background-color: #fff;
  width: 102%;
  margin-left: -1%;
  border-radius: 10px;
  padding: 2%;
}
.directbookroom > h5 {
  color: #000;
  font-weight: 800;
}
.directbookroom > h5 > small {
  font-size: 0.9rem;
}

.directbookroom > h5 > small::before {
  content: "\A";
  white-space: pre;
}

.inclusions > ul {
  padding-inline-start: 0px;
  list-style-type: none;
}
.inclusions > ul > li > small {
  font-size: 0.9rem;
  font-weight: 600;
  color: #083578;
}
.line {
  margin-top: 1em;
  border-bottom: 1px solid #000;
}
h6 {
  font-size: 0.9rem;
}
.list > ul > li {
  display: inline;
  padding: 0.1rem 1rem;
}
.list > ul > li:not(:last-child) {
  border-right: 1px solid #ccc;
}
.list > ul > li > a {
  color: #000;
}

.list > ul > li:hover {
  background-color: #ccc;
  text-decoration: none;
  border-top: 1px solid red;
}
.bookedbtn {
  height: 55px;
  margin-top: 1rem;
}
.bookedbtn > h6 {
  width: 50%;
  position: absolute;
  padding: 2%;
  font-size: 1rem;
  font-weight: 900;
}
.bookedbtn > .btn-primary {
  position: absolute;
  right: 9%;
  margin-top: 1%;
}
a:hover {
  text-decoration: none;
}

.col-md-9 > img {
  width: 100%;
}
#room {
  background-color: #fff;
  margin-top: 2rem;
  padding: 2rem 0;
  border-radius: 15px;
}
#room > .row {
  padding: 0 2rem;
}
.roomstable {
  width: 100%;
}
.roomstable > tr > th {
  text-align: center;
  color: #000;
}
.roomstable > tbody > tr > td {
  padding-left: 2rem;
  color: #000;
}
.single-hotel-detail,
.chooseroom,
.reviews {
  background-color: #fff;
  padding-top: 1rem;
  border-radius: 1rem;
  margin-bottom: 1rem;
}
.first > .chooseroom {
  padding-bottom: 1rem;
  padding-left: 7rem;
}
.buttonchek {
  margin-top: 1.7rem;
}
.hotel-text {
  padding: 0.5rem;
  margin: 0.5rem;
}
.active {
  color: #a52a2a;
}

.rooms > .col-md-2 {
  border: unset;
}

.buttonchek {
  display: flex;
  align-items: center;
}

.roomimages {
  width: 100%;
}
.boxborder {
  margin: 0 0rem;
  border: 0.05rem solid #cccccc;
  border-radius: 5px;
  background-color: #fff;
}

.boxborder:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}
.boxborder > .col-md-2 {
  border: unset;
}
.reviews {
  padding: 1.5rem 1rem;
  /* border-bottom: 1px solid #ccc; */
  border-radius: 10px;
}
.review-detail > .col-md-3:not(:first-child) {
  border-left: 1px solid #ccc;
}
.review-detail {
  text-align: center;
}
.hotelimg {
  cursor: pointer;
  max-width: 100%;
  /* height: 30em; */
  max-height: 40em;
}
.selectroom {
  max-width: 99%;
  /* border: 1px solid black; */
  padding: 0.5em;
  -webkit-box-shadow: 3px 9px 49px -30px rgba(0, 0, 0, 0.83);
  -moz-box-shadow: 3px 9px 49px -30px rgba(0, 0, 0, 0.83);
  box-shadow: 3px 9px 49px -30px rgba(0, 0, 0, 0.83);
}

.hoteltext {
  position: absolute;
  bottom: 17%;
  left: 4%;
  color: #fff;
  font-weight: 700;
}
.map {
  margin-top: 1rem;
  border: 0.1rem solid #000;
  border-radius: 15px;
}

.starsize {
  width: 15px;
  font-size: 0.9rem;
  margin-right: 0.1rem;
}
/* #room div{
  border: 0.1rem solid #000;

} */
.roomtable div {
  /* border: 0.05rem solid #000; */
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  padding: 1em;
}
.roomtable > .col-md-3 {
  max-width: 22%;
}
.roomtable > .col-md-2 {
  max-width: 22.5%;
  width: 22.5%;
  min-width: 22.5%;
}
.room_inclusions::v-deep > ul {
  margin-block-start: 0em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 10px;
}
.VueCarousel .roomcarousel {
  padding: 0%;
}

.room_inclusions::v-deep li:nth-of-type(1n + 10) {
  display: none !important;
}

@media (min-width: 300px)and (max-width: 769px) {
  .btn-primary {
    margin: auto;
  }
  /* #photos {
    display: flex;
    flex-direction: column-reverse;
  } */
  .single-hotel-detail > .col-sm-12 {
    margin-bottom: 2rem;
  }
  .hoteltext {
    margin-left: 0.5rem;
    bottom: 40%;
  }
  .review-detail > .col-md-3 {
    border: unset !important;
  }
  .overviewtext {
    text-align: justify;
  }
  ul {
    padding-inline-start: 10px;
  }
  .btn-success {
    margin-top: 1rem;
    width: 100%;
  }
  .list > ul {
    height: unset;
    width: 106%;
    margin-left: -3%;
    border-radius: 10px;
    padding-top: 1%;
  }
  .list > ul > li {
    display: block;
    border-right: 0px !important;
    border-bottom: 1px solid #cccccc60;
  }
  .first > .chooseroom {
    padding-left: 4%;
  }
  .bookedbtn > .btn-primary {
    position: unset;
    float: right;
    font-size: 0.7rem;
  }
  .roomhead,
  .list {
    display: none;
  }

  .roomtable {
    padding: 0 0.5rem 0.5rem 0.5rem;
  }
  .VueCarousel {
    padding: 0% !important;
  }
  .roomtable > .col-md-3,.roomtable > .col-md-2{
    max-width: 100%;
    min-width: 100%;
  }
}
.rhigh {
  color: green;
  font-weight: 500;
  font-size: 0.9em;
  display: inline-block;
}
.amenitiesspace {
  margin-left: 0em;
}
.amenities {
  color: green;
  font-weight: 500;
  font-size: 0.9em;
  display: block;
  margin-left: 0em;
}

.red {
  color: red;
  font-weight: 500;
  font-size: 0.9em;
  display: inline-block;
}
.roomtable > div > .roomimg {
  padding: 0.9em;
}
.roomimg {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 200px;
  max-height: 200px;
  border: none !important;
}
.roomcarousel {
  border: none;
  padding: 0%;
}
.roomtable .VueCarousel,
.roomcarousel.VueCarousel-wrapper.VueCarousel-inner,
.roomcarousel.VueCarousel-wrapper,
.roomcarousel.VueCarousel-wrapper.VueCarousel-inner.VueCarousel-slide {
  border: none;
}
.VueCarousel-slide-active {
  border: none;
}
</style>
<style>
.VueCarousel-slide {
  border: none !important;
  padding: 0 !important;
}
#room {
  background: rgb(226, 226, 226, 0.3);
}
.roomhead {
  font-weight: bold;
  padding-bottom: 1em;
  padding: 0.7em;
  width: 100%;
  background: rgb(226, 226, 226, 0.3);
}
.roomheader {
  background-color: grey;
}
.VueCarousel-pagination {
  width: 90% !important;
}
.VueCarousel-navigation-next,
.VueCarousel-navigation-prev {
  padding: 0% !important;
  margin-right: 0% !important;
}
</style>